import Warning from '@mui/icons-material/Warning';
import { AppBar, Paper, Tab, Tabs } from '@mui/material';
import { action, computed, makeObservable, observable, reaction, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import '../../css/processo.css';
import InformacoesProcesso from '../InformacoesProcesso';
import ReactComponent from '../ReactComponent';
import ConteudoVoto from './ConteudoVoto';
import PainelDecisao from './PainelDecisao/PainelDecisao';
import PecasProcesso from './PecasProcesso';
import { ABAS_DETALHES_PROCESSO } from '@/dominio/AbasDetalhesProcesso';

class DetalhesProcesso extends ReactComponent {
    pecas = [];
    composicao = [];
    alturaDivCabecalhoDetalhes = this.appStore.larguraJanela > 1400 ? 46 : 92;

    constructor(props) {
        super(props);

        makeObservable(this, {
            pecas: observable,
            composicao: observable,
            alturaDivCabecalhoDetalhes: observable,
            registro: computed,
            processo: computed,
            handleTab: action,
            tituloAbaVoto: computed,
            opcoesDetalhesProcesso: computed,
            opcoesDetalhesProcessoPreSessao: computed,
            labelDecisao: computed,
            valorAbaSelecionada: computed,
            valorAbaSelecionadaDetalhesProcesso: computed,
            atualizarAltura: action
        });

        this.createReaction(
            reaction(
                () => this.appStore.larguraJanela,
                () => {
                    this.atualizarAltura();
                }
            )
        );

        let aba;
        if (this.isPreSessao) {
            aba = ABAS_DETALHES_PROCESSO.DECISAO.id;
        } else {
            aba = ABAS_DETALHES_PROCESSO.PROCESSO.id;
        }

        runInAction(() => {
            this.store.abaSelecionadaDetalhesProcesso = aba;
        });

        // Carrega o conteúdo da aba selecionada quando o processo selecionado é alterado
        this.createReaction(
            reaction(
                () => this.registro,
                () => {
                    if (this.isPreSessao) {
                        this.handleTab(ABAS_DETALHES_PROCESSO.DECISAO.id);
                    } else if (
                        this.registro?.necessitaImportacaoSalaSessao &&
                        this.store.abaSelecionadaDetalhesProcesso === ABAS_DETALHES_PROCESSO.DECISAO.id
                    ) {
                        this.handleTab(ABAS_DETALHES_PROCESSO.PROCESSO.id);
                    } else {
                        let opcao = this.opcoesDetalhesProcesso.find(
                            (opcaoDetalhes) => opcaoDetalhes.id === this.store.abaSelecionadaDetalhesProcesso
                        );
                        this.handleTab(opcao ? opcao.id : ABAS_DETALHES_PROCESSO.PROCESSO.id);
                    }

                    setTimeout(() => {
                        const elemento = document.getElementById('detalhes-processo');

                        if (elemento !== null) {
                            elemento.focus();
                        }
                    }, 10);
                }
            )
        );
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        this.atualizarAltura();
    }

    atualizarAltura = () => {
        let divCabecalhoDetalhes = document.getElementById('divCabecalhoDetalhes');
        if (divCabecalhoDetalhes) {
            this.alturaDivCabecalhoDetalhes = divCabecalhoDetalhes.offsetHeight;
        }
    };

    get registro() {
        return this.store.processoSelecionado;
    }

    get processo() {
        return this.registro?.processo;
    }

    handleTab = (tabId) => {
        this.store.abaSelecionadaDetalhesProcesso = tabId;
    };

    get tituloAbaVoto() {
        if (
            this.registro?.acordaoAssinado ||
            this.registro?.informacoesAdicionais?.dataAssinaturaAcordao ||
            this.registro?.dataAssinaturaSistemaOrigem
        ) {
            return 'Acórdão';
        }

        return 'Voto';
    }

    get opcoesDetalhesProcesso() {
        let ordem = 0;
        let opcoes = [];
        if (this.isPreSessao) {
            return this.opcoesDetalhesProcessoPreSessao;
        }
        opcoes.push({ ...ABAS_DETALHES_PROCESSO.PROCESSO, ordem: ordem++ });
        if (this.isSalaSessao || (this.isPautaJulgamento && this.store.isProcessoEmPauta(this.registro))) {
            opcoes.push({
                ...ABAS_DETALHES_PROCESSO.DECISAO,
                label: this.labelDecisao,
                ordem: ordem++,
                disabled: this.registro?.necessitaImportacaoSalaSessao
            });
            opcoes.push({ ...ABAS_DETALHES_PROCESSO.VOTO, ordem: ordem++, label: this.tituloAbaVoto });
        }
        opcoes.push({ ...ABAS_DETALHES_PROCESSO.PECAS, ordem: ordem++ });

        return opcoes;
    }

    get opcoesDetalhesProcessoPreSessao() {
        let ordem = 0;
        let opcoes = [
            {
                ...ABAS_DETALHES_PROCESSO.DECISAO,
                label: this.labelDecisao,
                ordem: ordem++,
                disabled: this.registro?.necessitaImportacaoSalaSessao
            },
            { ...ABAS_DETALHES_PROCESSO.PROCESSO, ordem: ordem++ },
            { ...ABAS_DETALHES_PROCESSO.VOTO, ordem: ordem++, label: this.tituloAbaVoto },
            { ...ABAS_DETALHES_PROCESSO.PECAS, ordem: ordem++ }
        ];
        return opcoes;
    }

    get labelDecisao() {
        return (
            <div style={{ display: 'flex' }}>
                <span>Decisão</span>
                {this.registro?.necessitaImportacaoSalaSessao && (
                    <Warning style={{ fill: 'darkorange', marginLeft: '10px' }} />
                )}
            </div>
        );
    }

    get valorAbaSelecionada() {
        let opcao = this.opcoesDetalhesProcesso.find(
            (opcaoDetalhes) => opcaoDetalhes.id === this.store.abaSelecionadaDetalhesProcesso
        );

        return opcao ? opcao.ordem : 0;
    }

    get valorAbaSelecionadaDetalhesProcesso() {
        return this.store.abaSelecionadaDetalhesProcesso;
    }

    render() {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', flexGrow: '1', zIndex: '9' }}>
                <AppBar
                    position="static"
                    elevation={2}
                >
                    <Tabs
                        value={this.valorAbaSelecionada}
                        textColor="primary"
                        indicatorColor="primary"
                        centered={true}
                        sx={this.estiloAbas}
                        variant="fullWidth"
                    >
                        {this.opcoesDetalhesProcesso.map((opcao) => (
                            <Tab
                                key={`opcao-detalhes-processo-${opcao.id}`}
                                onClick={() => this.handleTab(opcao.id)}
                                sx={this.estiloAbas}
                                label={opcao.label}
                                disabled={opcao.disabled}
                            />
                        ))}
                    </Tabs>
                </AppBar>
                <Paper
                    style={{
                        display: 'flex',
                        flexGrow: '1',
                        margin: '1px 0px 0px',
                        padding: '10px'
                    }}
                    tabIndex={0}
                    id="detalhes-processo"
                    className="lista"
                    elevation={4}
                >
                    {this.valorAbaSelecionadaDetalhesProcesso === ABAS_DETALHES_PROCESSO.PROCESSO.id && (
                        <InformacoesProcesso registro={this.registro} />
                    )}
                    {this.valorAbaSelecionadaDetalhesProcesso === ABAS_DETALHES_PROCESSO.DECISAO.id && (
                        <PainelDecisao registro={this.registro} />
                    )}
                    {this.valorAbaSelecionadaDetalhesProcesso === ABAS_DETALHES_PROCESSO.VOTO.id && (
                        <ConteudoVoto registro={this.registro} />
                    )}
                    {this.valorAbaSelecionadaDetalhesProcesso === ABAS_DETALHES_PROCESSO.PECAS.id && (
                        <PecasProcesso
                            registro={this.registro}
                            sessaoId={this.store.idPautaSelecionada}
                        />
                    )}
                </Paper>
            </div>
        );
    }

    get estiloAbas() {
        return {
            bgcolor: 'background.paper',
            minHeight: '36px',
            minWidth: '140px'
        };
    }
}

export default inject('stores')(observer(DetalhesProcesso));
